import { useTranslation } from 'react-i18next'
import type { RohsProductComplianceFileDeclarationOfConformityRequirement } from '@/v2/lib/rohsProductComplianceFileDeclarationOfConformityRequirements'

const PAGE_REQUIREMENT_COUNT = 3

type RohsDeclarationReadinessProgressProps = {
  requirements: RohsProductComplianceFileDeclarationOfConformityRequirement[]
  generateReady: boolean
}

export function RohsDeclarationReadinessProgress({
  requirements,
  generateReady,
}: RohsDeclarationReadinessProgressProps) {
  const { t } = useTranslation('common')
  const pageRequirements = requirements.filter(
    (requirement) => requirement.key !== 'manufacturerIdentity'
  )
  const metCount = pageRequirements.filter((requirement) => requirement.met).length
  const progressPercent = Math.round((metCount / PAGE_REQUIREMENT_COUNT) * 100)

  return (
    <div className='space-y-2'>
      <div className='flex items-center justify-between gap-2 text-xs text-muted-foreground'>
        <span>
          {t('v2.pages.products.detail.rohsBriefing.declarationReadiness.label', {
            met: metCount,
            total: PAGE_REQUIREMENT_COUNT,
          })}
        </span>
      </div>
      <div
        className='h-1.5 w-full overflow-hidden rounded-full bg-muted'
        role='progressbar'
        aria-valuemin={0}
        aria-valuemax={PAGE_REQUIREMENT_COUNT}
        aria-valuenow={metCount}
        aria-label={t(
          'v2.pages.products.detail.rohsBriefing.declarationReadiness.label',
          {
            met: metCount,
            total: PAGE_REQUIREMENT_COUNT,
          }
        )}
      >
        <div
          className='h-full rounded-full bg-primary transition-[width]'
          style={{ width: `${progressPercent}%` }}
        />
      </div>
      {generateReady ? (
        <p className='text-xs text-muted-foreground'>
          {t('v2.pages.products.detail.rohsBriefing.declarationReadiness.readyHint')}
        </p>
      ) : null}
    </div>
  )
}
